module.exports = __webpack_public_path__ + "static/freedom-banner-4a476a4dff77b5bb5b0bc97c0fe6ab90.jpg";